<template>
    <div>
        <table
            class="table b-table b-table-stacked-md table-bordered table-sm bg-white"
        >
            <thead>
                <tr>
                    <th colspan="2">
                        <h4 class="text-center">{{ titulo }}</h4>
                    </th>
                </tr>
            </thead>
            <tbody v-if="item.usuario">
                <tr>
                    <td>
                        USUÁRIO:
                        <strong>{{ item.usuario.nome_completo }}</strong>
                    </td>
                    <td>
                        CPF/NIS:
                        <strong
                            >{{
                                item.usuario.documento
                                    ? item.usuario.documento.cpf
                                    : ""
                            }}/{{
                                item.usuario.documento
                                    ? item.usuario.documento.nis
                                    : ""
                            }}</strong
                        >
                    </td>
                </tr>
                <tr>
                    <td>
                        <span v-if="item.usuario.codigo_familiar">
                            CÓDIGO FAMILIAR:
                            <strong>{{ item.usuario.codigo_familiar }}</strong>
                        </span>
                        <span v-else>
                            ID FAMILIAR: <strong>{{ item.familia.id }}</strong>
                        </span>
                    </td>
                    <td>
                        POSIÇÃO FAMILIAR :
                        <strong>{{
                            getValue(
                                item.usuario.posicao_familiar,
                                $root.arrays.posicao_familiar
                            )
                        }}</strong>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">Endereço da Família:</td>
                </tr>
                <tr>
                    <td colspan="2" v-if="item.familia.endereco.situacao_rua">
                        Endereço marcado como Situação de Rua:
                        {{ item.familia.endereco.referencia_endereco }}
                    </td>
                    <td colspan="2" v-else>
                        LOGRADOURO:
                        <strong>
                            {{
                                item.familia.endereco.logradouro.tipo_logradouro
                            }}
                            {{
                                item.familia.endereco.logradouro
                                    .titulo_logradouro
                            }}
                            {{
                                item.familia.endereco.logradouro.nome_logradouro
                            }}
                        </strong>
                        - NÚMERO:
                        <strong>{{
                            item.familia.endereco.numero_endereco
                        }}</strong>
                        - BAIRRO/LOCALIDADE:
                        <strong v-if="item.familia.endereco.localidade">
                            {{
                                item.familia.endereco.localidade
                                    ? item.familia.endereco.localidade
                                          .nome_localidade
                                    : ""
                            }}</strong
                        >
                        <span
                            v-if="
                                item.familia.endereco.logradouro.cep_logradouro
                            "
                        >
                            - CEP:
                            <strong>{{
                                item.familia.endereco.logradouro.cep_logradouro
                            }}</strong>
                        </span>

                        <span v-if="item.familia.endereco.complemento">
                            <br />- COMPLEMENTO:
                            <strong>
                                {{ item.familia.endereco.complemento }}
                            </strong>
                        </span>

                        <span v-if="item.familia.endereco.referencia_endereco">
                            <br />- PONTO DE REFERÊNCIA:
                            <strong>
                                {{ item.familia.endereco.referencia_endereco }}
                            </strong>
                        </span>

                        <span v-if="item.familia.endereco.abrigo">
                            <br />- ENDEREÇO DE SERVIÇO DE ACOLHIMENTO
                        </span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        RESPONSAVEL PELA RETIRADA:
                        <strong>{{
                            item.nome_solicitante
                                ? item.nome_solicitante
                                : item.usuario.nome_completo
                        }}</strong>
                    </td>
                </tr>
                <tr>
                    <td>
                        BENEFÍCIO:
                        <strong>{{ item.beneficio.nome }}</strong>
                    </td>
                    <td>
                        <div class="row">
                            <div class="col-6">
                                QUANTIDADE:
                                <strong>{{ item.quantidade }}</strong>
                            </div>
                            <div class="col-6">
                                VALOR:
                                <strong> R$ {{ item.valor }}</strong>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <p>SITUAÇÃO RELATADA:</p>
                        <span v-html="item.observacoes"></span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <p>PARECER TÉCNICO:</p>
                        <span v-html="item.parecer_tecnico"></span>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        STATUS DO PARECER:
                        <strong v-html="item.status_parecer_nome"></strong>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        STATUS DA CONCESSÃO:<strong
                            v-html="item.status_nome"
                        ></strong>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="text-center" colspan="2">
                        <p class="text-muted mb-0">
                            {{ app_cidade }}, {{ app_data_atual }}
                        </p>
                    </td>
                </tr>
                <tr>
                    <td class="py-4" colspan="2"></td>
                </tr>
                <tr>
                    <td class="text-center" colspan="2">
                        <strong>{{ textFooter }}</strong>
                        <print-footer 
                            v-if=" item.responsavel.tecnico.assinatura_digital" 
                            :tecnico="item.responsavel.tecnico" 
                            class="mt-0" 
                            :showtext="false" 
                            :assinatura=" item.responsavel.tecnico.assinatura_digital"
                            :email="email"
                            :wpp="wpp"
                        />
         
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>
<script>
export default {
    props: ["item", "textFooter", "titulo", "wpp", "email"],
    data() {
        return {
            app_cidade: this.$store.state.settings.app_cidade,
            app_data_atual: this.$store.state.settings.app_data_atual,
        };
    },
    methods: {
        getValue(value, array) {
            const result = array.filter((item) => item.id == value);
            return result[0] ? result[0].value : "";
        },
    },
};
</script>

<style type="text/css">
table {
    page-break-inside: auto;
    page-break-inside: avoid;
    page-break-after: auto;
}
tr {
    page-break-inside: avoid;
    page-break-after: auto;
}
thead {
    display: table-header-group;
}
tfoot {
    display: table-footer-group;
    page-break-inside: avoid;
    page-break-after: auto;
}
</style>
